{
  "cms.upload.button": "Upload",
  "cms.upload.buttonReplace": "Replace file",
  "cms.upload.error.imageTooLarge": "Image is too large (max 10 MB).",
  "cms.upload.error.svgRejected": "SVG images cannot be uploaded.",
  "cms.upload.error.uploadFailed": "Upload failed. Please try again.",
  "cms.upload.error.videoTooLarge": "Video is too large (max 200 MB).",
  "cms.upload.error.wrongType.both": "File must be an image or video.",
  "cms.upload.error.wrongType.image": "File must be an image.",
  "cms.upload.error.wrongType.video": "File must be a video.",
  "cms.upload.helper.both": "Upload an image (max 10 MB) or video (max 200 MB).",
  "cms.upload.helper.image": "Upload an image (max 10 MB).",
  "cms.upload.helper.video": "Upload a video (max 200 MB).",
  "cms.upload.loading": "Uploading…",
  "cms.upload.remove": "Remove",
  "cms.upload.videoUrl.helper": "Paste a video link (https://) or upload a video file (max 200 MB).",
  "cms.upload.crop.trigger": "Crop image",
  "cms.upload.crop.title": "Crop image",
  "cms.upload.crop.description": "Select an area to crop, then save the crop.",
  "cms.upload.crop.aspect.label": "Aspect ratio",
  "cms.upload.crop.aspect.free": "Free",
  "cms.upload.crop.aspect.square": "1:1 (square)",
  "cms.upload.crop.imageAlt": "Image to crop",
  "cms.upload.crop.save": "Save crop",
  "cms.upload.crop.saving": "Saving…",
  "cms.upload.crop.cancel": "Cancel",
  "cms.upload.crop.noSelection": "Select a crop area first.",
  "cms.upload.crop.error": "Crop failed. Please try again.",
  "cms.upload.alt.label": "Alternative text (alt)",
  "cms.upload.alt.placeholder": "Briefly describe the image"
}
